<template>
  <div style="padding-bottom: 50px">
    <van-tabbar v-model="active" fixed active-color="#FACE89" inactive-color="#868E96" z-index="99" @change="onChange">
      <van-tabbar-item icon="home-o">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? icon01.active : icon01.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search">
        <span>会员服务</span>
        <template #icon="props">
          <img :src="props.active ? icon02.active : icon02.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search">
        <span>兑换</span>
        <template #icon="props">
          <img :src="props.active ? icon03.active : icon03.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="friends-o">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon04.active : icon04.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { isWechat } from '@/utils/common'

export default {
  name: 'Tabbar',
  data() {
    return {
      active: 2,
      icon01: {
        active: require('@/assets/img/icon-home-active.svg'),
        inactive: require('@/assets/img/icon-home.svg'),
      },
      icon02: {
        active: require('@/assets/img/icon-vip-active.svg'),
        inactive: require('@/assets/img/icon-vip.svg'),
      },
      icon03: {
        active: require('@/assets/img/icon-box-active.svg'),
        inactive: require('@/assets/img/icon-box.svg'),
      },
      icon04: {
        active: require('@/assets/img/icon-user-active.svg'),
        inactive: require('@/assets/img/icon-user.svg'),
      },
    }
  },
  watch: {
    $route() {},
  },
  computed: {},
  created() {},
  methods: {
    isWechat,
    onChange(index) {
      switch (index) {
        case 0:
          uni.switchTab({ url: '/pages/home/index' })
          break
        case 1:
          uni.switchTab({ url: '/pages/vip/index' })
          break
        case 2:
          break
        case 3:
          uni.switchTab({ url: '/pages/my/index' })
          break
      }
    },
  },
}
</script>
